/** Standard UUID — SQL uniqueidentifier expects uppercase on this API stack. */
const GUID_PATTERN =
  /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

export function isGuidString(value) {
  const text = String(value ?? "").trim();
  return text.length > 0 && GUID_PATTERN.test(text);
}

/** Uppercase a single GUID; pass through non-GUID values unchanged. */
export function guidToUpperCase(value) {
  if (value === undefined || value === null || value === "") return value;
  const text = String(value).trim();
  return isGuidString(text) ? text.toUpperCase() : value;
}

/** SQL params — never send "" or non-GUID for uniqueidentifier; uppercase when valid. */
export function guidOrNull(value) {
  const text = value != null ? String(value).trim() : "";
  if (!text) return null;
  return isGuidString(text) ? text.toUpperCase() : null;
}

/** Recursively uppercase GUID strings in API request bodies. */
export function normalizeGuidsDeep(value) {
  if (value === null || value === undefined) return value;
  if (Array.isArray(value)) {
    return value.map((item) => normalizeGuidsDeep(item));
  }
  if (typeof value === "object") {
    return Object.fromEntries(
      Object.entries(value).map(([key, item]) => [key, normalizeGuidsDeep(item)]),
    );
  }
  // GUIDs are 36 chars (optionally padded). Skip huge strings (e.g. file base64).
  if (typeof value === "string") {
    if (value.length > 40) return value;
    if (isGuidString(value)) return value.toUpperCase();
  }
  return value;
}
